/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GroupMareRequest } from '../models/GroupMareRequest';
import { HorseDetailsLocation } from '../models/HorseDetailsLocation';
import { SimpleHorseRequest } from '../models/SimpleHorseRequest';
import { HttpFile } from '../http/http';

export class StallionGroupRequest {
    'mares': Array<GroupMareRequest>;
    'stallion': SimpleHorseRequest;
    'locationString'?: string;
    'location'?: HorseDetailsLocation;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "mares",
            "baseName": "mares",
            "type": "Array<GroupMareRequest>",
            "format": ""
        },
        {
            "name": "stallion",
            "baseName": "stallion",
            "type": "SimpleHorseRequest",
            "format": ""
        },
        {
            "name": "locationString",
            "baseName": "locationString",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "HorseDetailsLocation",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return StallionGroupRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

